export default {"src":"/_next/static/media/hofMwebBanner.ab2aec12.svg","height":115,"width":336};